import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { AppDispatch, RootState } from "../../services/redux/store";
import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CircularProgress, Divider, Grid } from "@mui/material";
import { StepIconProps } from "@mui/material/StepIcon";
import CheckIcon from "@mui/icons-material/Check";
import ChevronsDown from "./../../assets/images/icons/chevrons-down.png";
import clipboardCheck from "./../../assets/svgIcons/clipboard-check.svg";
import booksCheck from "./../../assets/svgIcons/book line.svg";
import preLoginCalendar from "./../../assets/svgIcons/pre-login-calendar-icon.svg";
import preLoginClock from "./../../assets/svgIcons/pre-login-clock-icon.svg";
import preLoginProvisional from "./../../assets/svgIcons/pre-login-provisional-icon.svg";
import preLoginRupee from "./../../assets/svgIcons/pre-login-rupee-icon.svg";
import preLoginBottomBanner from "./../../assets/svgIcons/pre-login-right-banner-bottom-image.svg";
import { setCompletedStep } from "../../services/redux/slices/stepperSlice";
import DynamicForm from "../../components/ui/StepperDyanmicForm/DynamicForm";
import { authStatusSelector } from "../../services/redux/slices/authSlice";
import { mergeReferenceCollateralVerticalSteps } from "../../utils/helpers";

export interface StepConfig {
  label: string;
  FormComponent: React.ComponentType<{ onNext: () => void }>;
}
interface VerticalLinearStepperProps {
  steps: StepConfig[];
  onComplete?: () => void;
  reset?: boolean;
  icon?: React.ReactNode;
}

// Custom dashed connector with custom colors for active/completed lines
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 18,
    left: "calc(-50% + 18px)",
    right: "calc(50% + 18px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#D7D8DE",
      borderStyle: "dashed",
      borderTopWidth: "0px",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#D7D8DE",
      borderStyle: "dashed",
      borderTopWidth: "0px",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#D7D8DE",
    borderTopWidth: "0px",
    borderRadius: 1,
    borderStyle: "dashed",

  },
}));

const VerticalLinearStepper: React.FC<VerticalLinearStepperProps> = ({
  steps,
  onComplete,
  reset = false,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [completed, setCompleted] = React.useState<{ [key: number]: boolean }>(
    {}
  );
  const isAuthenticated = useSelector(authStatusSelector);
  // console.log('isAuthenticated', isAuthenticated);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const completedSteps = useSelector(
    (state: RootState) => state?.stepper?.completedSteps
  );
  const activeHorizontalIndex = useSelector(
    (state: RootState) => state?.stepper?.activeHorizontalIndex
  );
  const activeVerticalIndexVal = useSelector(
    (state: RootState) =>
      state?.stepper?.activeVerticalIndex?.[activeHorizontalIndex]
  );
  const resolvedSteps = React.useMemo<any[]>(() => {
    // Backend now sends Reference Details and Collateral Details as two
    // separate vertical steps instead of one combined step — collapse them
    // back into one so step count/indices (and the "Documents and Consent"
    // guard below) stay stable regardless of which shape the backend sends.
    const safeSteps = mergeReferenceCollateralVerticalSteps(
      Array.isArray(steps) ? steps : [],
    );
    const hasDocumentsAndConsent = safeSteps.some(
      (step: any) => step?.stepLabel === "Documents and Consent"
    );

    if (
      activeHorizontalIndex === 3 &&
      safeSteps.length === 4 &&
      !hasDocumentsAndConsent
    ) {
      const updateReferenceLabel = safeSteps.map(step =>
            step.stepLabel === 'Reference Details'
              ? { ...step, stepLabel: "Reference & Collateral Details" }
              : step
          );
      console.log(updateReferenceLabel,"safeSteps")
      return [
        ...updateReferenceLabel,
        {
          id: 5,
          stepOrder: 5,
          stepLabel: "Documents and Consent",
          fields: [],
        },
      ];
    }

    return safeSteps;
  }, [steps, activeHorizontalIndex]);

  const currentVerticalStep: any = resolvedSteps[activeVerticalIndexVal];
  const fields = currentVerticalStep?.fields || [];
  const title =
    activeHorizontalIndex === 0
      ? "Let's Check your Eligibility!"
      : activeHorizontalIndex === 1 && activeVerticalIndexVal === 0
      ? "Let's learn more about you!"
      : activeHorizontalIndex === 1 && activeVerticalIndexVal === 1
      ? "Alright, so far the application, could you let me know your address?"
      : activeHorizontalIndex === 1 && activeVerticalIndexVal === 2
      ? "Just Curious, what do you do for a living!"
      : activeHorizontalIndex === 1 && activeVerticalIndexVal === 3
      ? "So, tell me a bit about your academic background - what did you study!"
      : activeHorizontalIndex === 1 && activeVerticalIndexVal === 4
      ? "What entrance exam did you need to qualify through for your higher studies!"
      : activeHorizontalIndex === 1 && activeVerticalIndexVal === 5
      ? "Could you please elaborate on your financing needs & tell me about your Co-Applicants?"
      : activeHorizontalIndex===3 && activeVerticalIndexVal === 0
      ?"Next stop: Campus! Add your details now to speed up the process!"
      : activeHorizontalIndex===3 && activeVerticalIndexVal === 1
      ?"Introduce the co-applicants supporting your journey"
      : activeHorizontalIndex===3 && activeVerticalIndexVal === 2
      ?"Your Financial Snapshot: Share Income & Expense Details"
      : activeHorizontalIndex===3 && activeVerticalIndexVal === 3
      ?"Strengthen Your Application: References & Collateral"
      : activeHorizontalIndex===3 && activeVerticalIndexVal === 4
      ?"Fuel Your Application: Documentation & Consent"
      :"";

  const showCompletionRate = React.useMemo(() => {
    if (!resolvedSteps?.length) return 0;
    return activeVerticalIndexVal == 0
      ? 0
      : ((activeVerticalIndexVal + 1) / resolvedSteps.length) * 100;
  }, [resolvedSteps, activeVerticalIndexVal]);

  // React.useEffect(() => {
  //   if (!isAuthenticated) {
  //     window.location.replace("/login");
  //   }
  // }, [isAuthenticated])

  React.useEffect(() => {
    if (reset) {
      // setactiveVerticalIndex(0);
      setCompleted({});
    }
  }, [reset]);

  React.useEffect(() => {
    let copycompletedSteps: any = completedSteps?.[activeVerticalIndexVal];
    let copycompletedState: any = {};
    for (let i = 0; i <= copycompletedSteps; i++) {
      copycompletedState[i] = true;
    }
    setCompleted(copycompletedState);
  }, [completedSteps, activeVerticalIndexVal]);

  const handleNext = () => {
    setCompleted((prev) => ({ ...prev, [activeVerticalIndexVal]: true }));
    const copyCompletedSteps = { ...completedSteps };
    if (activeVerticalIndexVal === resolvedSteps.length - 1) {
      onComplete?.();
    } else {
      copyCompletedSteps["key"] = activeVerticalIndexVal;
      copyCompletedSteps["value"] = activeVerticalIndexVal + 1;
      dispatch(setCompletedStep(copyCompletedSteps));
    }
  };

  const handleBack = () => {
    const copyCompletedSteps = { ...completedSteps };
    copyCompletedSteps["key"] = activeVerticalIndexVal;
    copyCompletedSteps["value"] = activeVerticalIndexVal - 1;
    dispatch(setCompletedStep(copyCompletedSteps));
  };

  // Custom StepIcon Component for mobile view with check icon on completed steps
  const MobileStepIcon: React.FC<StepIconProps> = (props) => {
    const { active, completed, icon }: any = props;
    const shouldShowCheckmark = completed || activeVerticalIndexVal >= icon;

    return (
      <Box
        sx={{
          width: 36,
          height: 36,
          fontSize: 14,
          borderRadius: "50%",
          border: "1.33px solid rgba(215, 216, 222, 1)",
          color: "#B465C",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          userSelect: "none",

          // Active step styling (overrides default)
          ...(active &&
            !shouldShowCheckmark && {
              backgroundColor: "#fff",
              color: "#00B3B5",
              border: "2px solid #00B3B5",
              boxShadow: "none",
            }),

          // Completed/Checked step styling (overrides all others)
          ...(shouldShowCheckmark && {
            backgroundColor: "#00B3B5",
            color: "white",
            border: "2px solid #00B3B5",
            boxShadow: "none",
          }),
        }}
      >
        {shouldShowCheckmark ? (
          <CheckIcon sx={{ fontSize: 20, color: "white" }} />
        ) : (
          icon
        )}
      </Box>
    );
  };

  // --- MOBILE: Horizontal stepper with custom icons and dashed connectors ---
  if (isMobile) {
    return (
      <Box
        sx={{
          background: "#fff",
          borderRadius: 2,
          boxShadow: 1,
          pt: 2,
          maxWidth: "100%",
        }}
      >
        <Stepper
          activeStep={activeVerticalIndexVal}
          alternativeLabel
          connector={<CustomConnector />}
        >
          {resolvedSteps.map((_, idx) => {
            const isExplicitlyCompleted = !!completed[idx];
            const isPreviousStep = idx < activeVerticalIndexVal;
            const isSpecialCaseCompleted =
              activeHorizontalIndex === 0 &&
              activeVerticalIndexVal === 3 &&
              idx === 3;

            // Combine all conditions to determine if the Step should receive the 'completed' prop
            const stepCompletedProp =
              isExplicitlyCompleted || isPreviousStep || isSpecialCaseCompleted;

            return (
              <Step key={idx} completed={stepCompletedProp}>
                <StepLabel StepIconComponent={MobileStepIcon}>
                  <span style={{ display: "none" }} />
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>

        <Box sx={{ paddingLeft: "15px", paddingRight: "15px" }}>
          <Typography
            variant="caption"
            sx={{
              fontFamily: "Jost",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "20px",
              letterSpacing: "0px",
              verticalAlign: "middle",
              background:
                "linear-gradient(0deg, #4B465C, #4B465C), linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5))",
              backgroundBlendMode: "overlay",
            }}
          >
            <span style={{ color: "rgba(0, 179, 181, 1)" }}>
              Step {activeVerticalIndexVal + 1}{" "}
            </span>
            <span style={{ color: "#7a797b" }}>of {resolvedSteps.length}</span>
          </Typography>
          <Divider
            sx={{ color: "rgba(215, 216, 222, 1)", paddingTop: "4px" }}
          />
        </Box>

        {/* Step content */}
        <Box pl={2} pr={2} pb={3}>
          {(() => {
            const StepForm = resolvedSteps[activeVerticalIndexVal]?.FormComponent;
            return StepForm ? <StepForm onNext={handleNext} /> : null;
          })()}

          <DynamicForm fields={fields} />
        </Box>
      </Box>
    );
  }

  // --- DESKTOP: Vertical stepper with labels, arrows, and check icons on completed steps ---
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "stretch",
          gap: 3,
          width: "100%",
        }}
      >
        <Box sx={{ flex: 1, width: "100%", minWidth: 0 }}>
          <div
            className="card-contaner"
            style={{ paddingLeft: "0px", paddingRight: "0px", height: "100%"  }}
          >
            <Grid container sx={{ borderBottom: "1px solid #dbdade", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid item xs={12} md={9}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 1,
                    ml: 2,
                    mt: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 40,
                      height: 40,
                      borderRadius: "8px",
                      bgcolor: "#e5feffff",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={
                        activeHorizontalIndex === 0
                          ? clipboardCheck
                          : booksCheck
                      }
                      alt="icon"
                      style={{
                        width: 25,
                        height: 25,
                      }}
                    />
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      color: "#333",
                      fontSize: "1rem",
                    }}
                  >
                    {title}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={3}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    gap: 1.5,
                    textAlign: "right",
                    mr: 2,
                    ml: { xs: 2, md: 0 },
                    mb: { xs: 1.5, md: 0 },
                  }}
                >
                  {/* <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "#616161",
                      fontSize: "0.9rem",
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Completion Rate:
                    <Typography
                      component="span"
                      sx={{
                        fontWeight: 600,
                        color: "#00b3b5",
                        ml: 0.5,
                        fontSize: "0.9rem",
                      }}
                    >
                      {Math.floor(showCompletionRate)}%
                    </Typography>
                  </Typography> */}

                  <Box sx={{ position: "relative", display: "inline-flex" }}>
                    {/* <CircularProgress
                      variant="determinate"
                      value={showCompletionRate}
                      size={28}
                      thickness={4}
                      sx={{
                        color: "#00b3b5",
                        position: "absolute",
                        left: 0,
                        top: 0,
                        zIndex: 1,
                      }}
                    />
                    <CircularProgress
                      variant="determinate"
                      value={100}
                      size={28}
                      thickness={4}
                      sx={{
                        color: "#e0e0e0",
                      }}
                    /> */}
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", flexDirection: "row", minHeight: "560px" }}>
              <Box
                sx={{
                  borderRight: "1px solid #dcdddf",
                  minWidth: 120,
                  width: "140px",
                  display: { xs: "none", sm: "flex" },
                  padding: "20px 10px",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {resolvedSteps.map((step: any, index: any) => {
                  const isActive = index === activeVerticalIndexVal;
                  const isCompleted = !!completed[index];
                  const isPrevActive = index < activeVerticalIndexVal;

                  return (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mb: 1,
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          backgroundColor:
                            isCompleted ||
                            (activeHorizontalIndex === 0 &&
                              activeVerticalIndexVal === 3 &&
                              index === 3)
                              ? "#28C76F"
                              : isActive
                              ? "#fff"
                              : isPrevActive
                              ? "#28C76F"
                              : "#fff",
                          border:
                            isCompleted ||
                            (activeHorizontalIndex === 0 &&
                              activeVerticalIndexVal === 3 &&
                              index === 3)
                              ? "0px solid #00B3B5"
                              : isActive
                              ? "2px solid #00B3B5"
                              : isPrevActive
                              ? "2px solid #28C76F"
                              : "3px solid #4B465C14",
                          color:
                            isCompleted ||
                            (activeHorizontalIndex === 0 &&
                              activeVerticalIndexVal === 3 &&
                              index === 3)
                              ? "#fff"
                              : isActive
                              ? "#00B3B5"
                              : isPrevActive
                              ? "#00B3B5"
                              : "#5d586c",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 600,
                          fontSize: 16,
                          mb: 1,
                          textAlign: "center",
                        }}
                        className={
                          isCompleted ||
                          (activeHorizontalIndex === 0 &&
                            activeVerticalIndexVal === 3 &&
                            index === 3)
                            ? "is-completed"
                            : ""
                        }
                      >
                        {isCompleted ||
                        isPrevActive ||
                        (activeHorizontalIndex === 0 &&
                          activeVerticalIndexVal === 3 &&
                          index === 3) ? (
                          <CheckIcon sx={{ fontSize: 20, color: "white" }} />
                        ) : (
                          index + 1
                        )}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            mb: 0.5,
                            fontWeight: 700,
                            fontSize: "11px",
                            color: isActive ? "#4B465C" : "#5d586c",
                            whiteSpace: "pre-line",
                            wordBreak: "break-word",
                            textAlign: "center",
                            lineHeight: 1.2,
                          }}
                        >
                          {step.stepLabel}
                        </Typography>
                        {index < resolvedSteps.length - 1 && (
                          <img
                            src={ChevronsDown}
                            alt="path arrow"
                            style={{ marginTop: "4px", marginBottom: "4px" }}
                          />
                        )}
                      </Box>
                    </Box>
                  );
                })}
              </Box>

              <Box sx={{ flex: 1, px: { xs: 2, md: 3 }, py: 3 }}>
                <DynamicForm fields={fields} />
              </Box>
            </Box>
          </div>
        </Box>

        {!isAuthenticated && (activeHorizontalIndex === 0 && activeVerticalIndexVal < 3) && (
          <Box
            sx={{
              width: { xs: "100%", md: 350 },
              minWidth: { md: 350 },
              maxWidth: 350,
              flexShrink: 0,
              display: { xs: "none", md: "block" },
              bgcolor: "#00B3B514",
              borderRadius: "12px",
              p: 3,
            }}
          >
            {/* Inner Container */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              {/* Top Section: Title + Features */}
              <Box sx={{ flexGrow: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "24px",
                    fontWeight: 500,
                    color: "#1F2233",
                    mb: 3,
                  }}
                >
                  Student Loan International
                </Typography>

                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "20px",
                    fontWeight: 500,
                    color: "#000000",
                    mb: 1,
                  }}
                >
                  Product Features
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                  {/* Feature 1 */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={preLoginRupee}
                      alt="100% Financing"
                      style={{ width: 60, height: 60 }}
                    />
                    <Typography sx={{ fontWeight: 500, fontSize: '16px', color: "#1F2233", ml: 1 }}>
                      100% Financing
                    </Typography>
                  </Box>

                  {/* Feature 2 */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={preLoginClock}
                      alt="Eligibility Check"
                      style={{ width: 60, height: 60 }}
                    />
                    <Typography sx={{ fontWeight: 500, fontSize: '16px', color: "#1F2233", ml: 1 }}>
                      Eligibility Check in 3 Minutes
                    </Typography>
                  </Box>

                  {/* Feature 3 */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={preLoginProvisional}
                      alt="Provisional Letter"
                      style={{ width: 60, height: 60 }}
                    />
                    <Typography sx={{ fontWeight: 500, fontSize: '16px', color: "#1F2233", ml: 1 }}>
                      Provisional Letter in 12 Minutes
                    </Typography>
                  </Box>

                  {/* Feature 4 */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={preLoginCalendar}
                      alt="Flexible Repayments"
                      style={{ width: 60, height: 60 }}
                    />
                    <Typography sx={{ fontWeight: 500, fontSize: '16px', color: "#1F2233", ml: 1 }}>
                      Flexible Repayments
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Bottom Banner Image */}
              <Box sx={{ textAlign: "center", mt: 3 }}>
                <img
                  src={preLoginBottomBanner}
                  alt="Student Loan Illustration"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default VerticalLinearStepper;
